import React from "react";
import moment from "moment";

type DateProps = {
  date: string | Date;
  className?: string;
};

const DateFormat: React.FC<DateProps> = ({ date, className }) => {
  const formattedDate = date ? moment(date).format("DD/MM/YYYY HH:mm:ss") : "";
  return <div className={className ?? ""}>{formattedDate}</div>;
};

export default DateFormat;
